<template>
  <div class="document-viewer">
    <iframe :src="ruta" width="100%" height="600px" frameborder="0" />
  </div>
</template>

<script setup lang="ts">

import { messageBoxResult } from '@components/dialogs/message-box';
import { useModalBuilder, type ToolbarReference } from '@helpers/modal-building-helper';
import { useIntl } from '@services/i18n/i18nservice';
import type { DxButton } from 'devextreme-vue';
import type { ToolbarItem } from 'devextreme/ui/popup';
import { getCurrentInstance, onMounted } from 'vue';

const props = defineProps<{
  ruta: string,
  botones?: Array<{
      id: string,
      widgetOptions: Omit<DxButton,"onClick"> & {onClick: (closeFn: () => void, e: any) => void}, 
      itemOptions?:  Omit<ToolbarItem, "widget" | "options">;
  }>
}>();
const intl = useIntl();

onMounted(async () => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!)

  configureButtons(modal);
});

const configureButtons = (modal: ReturnType<typeof useModalBuilder>) => {
  if (props.botones) {
    props.botones.forEach(boton => {
        if (boton.widgetOptions.onClick) {
            const originalOnClick = boton.widgetOptions.onClick;
            boton.widgetOptions.onClick = (e: any) => {
            originalOnClick(() => modal.close(messageBoxResult.ok), e);
            };
        }
    modal.addButton(boton.id, boton.widgetOptions as Omit<DxButton,"onClick">, boton.itemOptions);
    });
  }
  let okButton: ToolbarReference<DxButton>;
  let cerrar = `${intl.i18n.t("shared.ui.buttons.close")}`;
  okButton = modal.standardButtons.addOk();
  okButton.update(w => w.text = cerrar);
  okButton.update(w => w.onClick = () => modal.close(messageBoxResult.ok));
}

</script>

<style scoped>
.document-viewer {
  border: none;
}
</style>